import { render } from "./transferView.vue?vue&type=template&id=310807d2"
import script from "./transferView.vue?vue&type=script&lang=js"
export * from "./transferView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Programming\\Padmaweb\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__